import { Select } from '@weareopenr/component-library';
import styles from './PriceSchemeSelectorBase.module.scss';
import { usePriceSchemes } from '../../../hooks/usePriceSchemes';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

type PriceSchemeSelectorBaseProps = {
  value: string | undefined;
  onChange: (id: string) => void;
  className?: React.HTMLAttributes<HTMLDivElement>['className'];
};

export const PriceSchemeSelectorBase = ({ onChange, value, className }: PriceSchemeSelectorBaseProps) => {
  const { isLoading: isPriceSchemesLoading, data: priceSchemes = [] } = usePriceSchemes();

  const priceSchemeOptions = priceSchemes.map((scheme) => ({
    value: scheme.id,
    name: scheme.name,
  }));

  return (
    <div className={cx('price-scheme-select-container', className)}>
      <Select
        label="Price scheme"
        loading={isPriceSchemesLoading}
        disabled={isPriceSchemesLoading}
        options={priceSchemeOptions}
        onChange={onChange}
        value={value}
      />
    </div>
  );
};
